export default __webpack_public_path__ + "static/media/imgBoatSteps.59e20fbf.png";